//환경설정 데이터
import { biddingFunc } from '../controller/assets/sub/biddingFunc';

//Sass 컴파일
import '../../sass/sub/_bidding.scss';

const biddingList = {
	init:function() {
		//검색 관련 함수
		this.searchCheck();
	},
	searchCheck:function() {
		$('.bidding-radio, label').click(function() {
			var biddingType = $(this).parents('span').attr('id');
			var compareSel = '.comparison_select_wrap select';
			if(biddingType == 'look-box') {
				$(compareSel).prop('disabled',true).attr('validation','no');
			}else{
				$(compareSel).prop('disabled',false).attr('validation','yes');
			}
		});
	}
}
biddingList.init();



// WEBPACK FOOTER //
// ./js/sub/bidding.js